import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Turn as Hamburger } from "hamburger-react";
import ANSSAFETYNTESLOGO from "../assets/logoANS.png";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);
  const toggleSubMenu = () => setIsSubMenuOpen(!isSubMenuOpen);

  return (
    <nav className="backdrop-blur-xl bg-white/80 dark:bg-black/40 h-[90px] shadow-lg fixed w-full z-50 border-b border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-[90px] relative">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <img
                src={ANSSAFETYNTESLOGO}
                alt="ANS Safety Nets Logo"
                className="h-[70px] w-auto object-contain transition-transform duration-300 hover:scale-105"
                loading="lazy"
              />
            </Link>
          </div>

          {/* Mobile Center Text */}
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 md:hidden">
            <p className="text-[18px] font-semibold text-gray-900 tracking-wide">
              Invisible Grills
            </p>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8 font-semibold text-gray-800">
            <Link to="/" className="hover:text-blue-600 transition">
              Home
            </Link>
            <Link to="/about" className="hover:text-blue-600 transition">
              About
            </Link>

            {/* Desktop Dropdown */}
            <div className="relative group">
              <button className="hover:text-blue-600 transition">
                Services
              </button>
              <div className="absolute hidden group-hover:block w-64 bg-white border shadow-xl rounded-xl p-3 top-8">
                {submenuItems.map((item, idx) => (
                  <Link
                    key={idx}
                    to={item.href}
                    className="block px-3 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition"
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>

            <Link to="/contact" className="hover:text-blue-600 transition">
              Contact
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <Hamburger
              toggled={isOpen}
              toggle={toggleMenu}
              color="#111"
              size={24}
            />
          </div>
        </div>
      </div>

      {/* Mobile Navigation Drawer */}
      <div
        className={`md:hidden backdrop-blur-xl bg-white/95 dark:bg-black/50 border-t transition-all duration-500 shadow-lg ${
          isOpen ? "max-h-[80vh] py-4" : "max-h-0"
        } overflow-y-auto`}
      >
        <div className="px-4 space-y-3">
          {/* Main Links */}
          <Link
            to="/"
            onClick={closeMenu}
            className="block text-lg font-semibold text-gray-800"
          >
            Home
          </Link>

          <Link
            to="/about"
            onClick={closeMenu}
            className="block text-lg font-semibold text-gray-800"
          >
            About
          </Link>

          {/* Services Toggle */}
          <button
            onClick={toggleSubMenu}
            className="w-full flex justify-between items-center px-4 py-3 rounded-lg bg-gray-100 border text-gray-800 font-medium"
          >
            Services
            <span
              className={`transform transition-transform duration-300 ${
                isSubMenuOpen ? "rotate-180" : ""
              }`}
            >
              ↑
            </span>
          </button>

          {/* Scrollable Modern Submenu */}
          <div
            className={`${
              isSubMenuOpen ? "block" : "hidden"
            } pl-2 max-h-[50vh] overflow-y-auto pr-2 space-y-3 scrollbar-thin scrollbar-thumb-gray-300`}
          >
            {submenuItems.map((item, index) => (
              <Link
                key={index}
                to={item.href}
                onClick={closeMenu}
                className="
                      block
                      px-4 py-3
                      bg-white
                      rounded-xl
                      border border-gray-200
                      shadow-sm
                      text-gray-800
                      font-medium
                      transition-all
                      duration-200
                      hover:shadow-md
                      hover:-translate-y-[2px]
                      active:scale-[0.97]
                    "
              >
                {item.label}
              </Link>
            ))}
          </div>

          {/* Contact */}
          <Link
            to="/contact"
            onClick={closeMenu}
            className="block text-lg font-semibold text-gray-800"
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
}

/* Submenu Items */
const submenuItems = [
  { href: "/invisiblegrills", label: "Invisible Grills" },
  { href: "/balconysafenets", label: "Balcony Safety Nets" },
  { href: "/childernsafetynets", label: "Children Safety Nets" },
  { href: "/industrialsafetynets", label: "Industrial Safety Nets" },
  { href: "/petssafetynets", label: "Pets Safety Nets" },
  { href: "/ducterianets", label: "Ducteria Nets" },
  { href: "/monkeysafetynets", label: "Monkey Safety Nets" },
  { href: "/cricketpracticenets", label: "Cricket Practice Nets" },
  { href: "/birdspikes", label: "Bird Spikes" },
  { href: "/blogs", label: "Our Blogs" },
];
